import { defineMessages } from 'react-intl';

export default defineMessages({
  native: 'Native',
  pageTitle: 'Markets',
  selectMarket: 'Select a market',
  rewardsInformation: 'Rewards information',
});
